import { ChecklistTemplate, ChecklistSection, ChecklistItem, FieldType } from '../types';
import { DEFAULT_CONDITION_OPTIONS } from '../constants';

export const generateId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const createEmptyTemplate = (): ChecklistTemplate => ({
  id: generateId(),
  project: '',
  area: null,
  title: '',
  description: '',
  is_template: true,
  template_source: null,
  created_by: '',
  created_at: new Date().toISOString(),
  updated_by: '',
  updated_at: new Date().toISOString(),
  sections: [],
});

export const createEmptySection = (
  checklistId: string = '',
  order: number = 1
): ChecklistSection => ({
  id: generateId(),
  checklist: checklistId,
  title: '',
  order: order,
  is_collapsed: false,
  items: [],
});

export const createEmptyItem = (
  sectionId: string = '',
  fieldType: FieldType = 'Free Text',
  order: number = 1
): ChecklistItem => ({
  id: generateId(),
  section: sectionId,
  name: '',
  title: '',
  is_completed: false,
  field_type: fieldType,
  order: order,
  is_required: false,
  condition_options:
    fieldType === 'Condition'
      ? [
          ...DEFAULT_CONDITION_OPTIONS.map((opt, index) => ({
            ...opt,
            id: generateId(),
            item: generateId(),
            order: index + 1,
          })),
        ]
      : [],
  response: null,
});

export const moveArrayItem = <T>(array: T[], fromIndex: number, toIndex: number): T[] => {
  const newArray = [...array];
  const [movedItem] = newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, movedItem);
  return newArray;
};

export const validateTemplate = (template: ChecklistTemplate): string[] => {
  const errors: string[] = [];

  if (!template.title.trim()) {
    errors.push('Template title is required');
  }

  if (template.sections.length === 0) {
    errors.push('At least one section is required');
  }

  template.sections.forEach((section, sectionIndex) => {
    if (!section.title.trim()) {
      errors.push(`Section ${sectionIndex + 1} title is required`);
    }

    section.items.forEach((item, itemIndex) => {
      if (!item.name.trim()) {
        errors.push(
          `Item ${itemIndex + 1} in section "${section.title || sectionIndex + 1}" name is required`
        );
      }

      if (
        item.field_type === 'Condition' &&
        (!item.condition_options || item.condition_options.length === 0)
      ) {
        errors.push(`Condition field "${item.name}" must have at least one option`);
      }
    });
  });

  return errors;
};
